<ng-container [formGroup]="form">
  <ix-input
    formControlName="url"
    [label]="'Webhook URL' | translate"
    [required]="true"
    [tooltip]="helptext.Slack_url_tooltip | translate"
    [parse]="formatter.stringAsUrlParsing"
  ></ix-input>
</ng-container>
